import * as actionTypes from '../actions/actionTypes';

const initialState = {
    reseller: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SAVE_RESELLER_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                reseller: null
            };
        case actionTypes.SAVE_RESELLER_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                reseller: null
            };
        case actionTypes.SAVE_RESELLER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                reseller: null
            };
        case actionTypes.SAVE_RESELLER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                reseller: action.payload
            };
        default:
            return state;
    }
};

export default reducer;